import { render, staticRenderFns } from "./VocDetail.vue?vue&type=template&id=69c7f77b"
import script from "./VocDetail.vue?vue&type=script&lang=js"
export * from "./VocDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69c7f77b')) {
      api.createRecord('69c7f77b', component.options)
    } else {
      api.reload('69c7f77b', component.options)
    }
    module.hot.accept("./VocDetail.vue?vue&type=template&id=69c7f77b", function () {
      api.rerender('69c7f77b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/common/VocDetail.vue"
export default component.exports